export default __webpack_public_path__ + "static/media/logo_marchand.cfdb8155.png";